import { FC, Suspense } from 'react';

import { CURRENCIES } from '@savgroup-front-common/constants';
import { Skeleton } from '@savgroup-front-common/core/atoms/Skeleton';
import { BannersConsumer } from '@savgroup-front-common/core/molecules/NotificationsProvider';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

import { PaymentContent } from './PaymentContent';

interface PaymentProps {
  invoice: { id: string; priceWithTax: number; currencyTrigram: CURRENCIES };
  onSubmitSuccess: () => Promise<void>;
  isFormCompleted: boolean;
  claimGroupId: string;
  fileId?: string;
}

export const Payment: FC<PaymentProps> = ({
  invoice,
  isFormCompleted,
  onSubmitSuccess,
  claimGroupId,
  fileId,
}) => {
  return (
    <Suspense fallback={<Skeleton width="100%" height={rem(280)} />}>
      <BannersConsumer isFluid />

      <PaymentContent
        invoice={invoice}
        isFormCompleted={isFormCompleted}
        onSubmitSuccess={onSubmitSuccess}
        claimGroupId={claimGroupId}
        fileId={fileId}
      />
    </Suspense>
  );
};
